<div>
  <input
    #autoInput
    nbInput
    [fullWidth]="fullWidth"
    [status]="isErr ? 'danger' : status"
    type="text"
    (input)="onChange()"
    [placeholder]="placeholder"
    [nbAutocomplete]="auto"
    (blur)="checkErr()"
    (click)="resetErr()"
    [nbPopover]="warningContent"
    nbPopoverTrigger="noop"
    [nbPopoverPlacement]="nbPopoverPlacement"
    [ngStyle]="styleInput"
  />

  <nb-icon
    icon="alert-triangle-outline"
    status="warning"
    *ngIf="isErr"
  ></nb-icon>

  <nb-autocomplete #auto (selectedChange)="onSelectionChange($event)">
    <nb-option *ngIf="data.length == 0">{{ messageNoData }}</nb-option>

    <nb-option
      *ngFor="let option of filteredOptions$ | async; index as i"
      [value]="i"
    >
      {{ option }}
    </nb-option>
  </nb-autocomplete>
</div>
